import React, { useState } from 'react';
import { useParams } from 'react-router';
import { useGetSurveyByIdQuery, useShuffleSurveyQuestionsMutation } from '../../app/surveyApi/surveyApi';
import { getQuestionLabel } from '../../helpers/Utils';
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb';
import Loader from '../../components/shared/loader/Loader';
import { useLocation } from 'react-router';
import { RiDragMoveFill } from 'react-icons/ri';
import { toast } from 'react-toastify';
import Accordion from 'react-bootstrap/Accordion';
const SureveyDetails = () => {
  const { state } = useLocation();
  const cateId = state?.cateId
  const { id } = useParams();
  const { data: surveyDetails, isLoading, refetch } = useGetSurveyByIdQuery(id);
  const [shuffleSurveyQuestions, { isLoading: isShuffling }] = useShuffleSurveyQuestionsMutation();
  const [draggedIndex, setDraggedIndex] = useState(null);

  const breadcrumbItems = [
    { label: 'Survey Category', path: '/survey-category' },
    { label: 'Survey ', path: `/survey-category/survey/${cateId}` },
    { label: `Survey Details - ${id}` }, // last one (no path) is the current page
  ];

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = async (e, dropIndex) => {
    e.preventDefault();

    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      return;
    }

    try {
      const payload = {
        fromLabelId: draggedIndex + 1, // Convert to 1-based sequence
        toLabelId: dropIndex + 1,      // Convert to 1-based sequence
        surveyId: id
      };

      await shuffleSurveyQuestions({ body: payload }).unwrap();
      toast.success('Questions reordered successfully!');
      refetch(); // Refresh the survey data
    } catch (error) {
      console.error('Error shuffling questions:', error);
      toast.error('Failed to reorder questions. Please try again.');
    } finally {
      setDraggedIndex(null);
    }
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };
  if (isLoading) {
    return (
      <Loader />
    );
  }
  return (
    <>
      <div>
        <CommonBreadcrumb items={breadcrumbItems} />
      </div>
      <div className='d-flex gap-3 align-itmes-center'>
        <div>
          <img src={surveyDetails?.data?.survey_image} alt="" className='rounded' width={60} height={60} />
        </div>
        <div>
          <h1 className="cmn_heading">{surveyDetails?.data?.title}</h1>
          <p className="sr-desc">{surveyDetails?.data?.description}</p>
        </div>
      </div>

      {isShuffling && (
        <div className="alert alert-info d-flex align-items-center gap-2 mb-3">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <span>Reordering questions...</span>
        </div>
      )}

      <div className="mb-3">
        <small className="text-muted">
          <strong>Tip:</strong> Drag and drop questions to reorder them
        </small>
      </div>
      <Accordion defaultActiveKey="0" className='border-0 d-flex flex-column gap-2 quesition_accordian'>
        {surveyDetails?.data?.questions.map((ques, index) => {
          const { label, image } = getQuestionLabel(ques?.questionType);
          console.log(ques, 'ques--->');

          return (
            <Accordion.Item eventKey={index.toString()} className='border-0 rounded-2 p-0'>
              <div
                className={` ${draggedIndex === index ? 'dragging' : ''} ${isShuffling ? 'disabled' : ''}`}
                key={index}
                draggable={!isShuffling}
                onDragStart={(e) => handleDragStart(e, index)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, index)}
                onDragEnd={handleDragEnd}
                style={{
                  cursor: isShuffling ? 'not-allowed' : 'move',
                  opacity: draggedIndex === index ? 0.5 : 1,
                  transition: 'opacity 0.2s ease'
                }}
              >
                <div className="quesions">
                  <Accordion.Header>
                    <div className="d-flex gap-3 align-items-start flex-wrap w-100 align-items-center">
                      {image && (
                        <img
                          className='flex-shrink-0'
                          src={ surveyDetails?.data?.survey_image || image}
                          alt={label}
                          style={{ width: 30, height: 30, objectFit: 'contain' }}
                        />
                      )}
                      <div className='question-wrapper flex-grow-1'>
                        <h5 className="ques-title mb-2">{ques?.text}</h5>

                        <p className="m-0 ques-type "> <strong>Question Type:</strong> {label}</p>
                        <p className="m-0 ques-type pt-2 "><strong>Tooltip:</strong> {ques?.tooltip}</p>
                        {ques.imageUrl && (
                          <div className='mt-2'>
                            <img src={ques.imageUrl} alt="Question" style={{ width: 60, height: 60 }} className='rounded-2' />
                          </div>
                        )}

                      </div>
                      <RiDragMoveFill
                        size={24}
                        className='me-3'
                        style={{
                          color: isShuffling ? '#ccc' : '#666',
                          cursor: isShuffling ? 'not-allowed' : 'grab'
                        }}
                      />
                    </div>
                  </Accordion.Header>
                  <Accordion.Body className='pt-0'>
                    <div>
                      {Array.isArray(ques?.options) && ques.options.length > 0 && (
                       <div>
                        <h5>Options</h5>
                       <ul className=' d-flex flex-column gap-2 border-0 padding-0'>
                          {ques.options.map((opt, index) => (
                            <li key={index} className='text-sm text-muted'>{opt?.label}</li>
                          ))}
                        </ul>
                       </div>
                      )}
                      {((Array.isArray(ques?.options) && ques.options.length === 0) && (Array.isArray(ques?.subQuestions) && ques.subQuestions.length === 0)) && (
                        <div className="text-muted mb-0">
                          <p>No additional details for this question.</p>
                        </div>
                      )}
                      {ques?.min && <span className='d-block'>Min: {ques?.min}</span>}
                      {ques?.max && <span>Max: {ques?.max}</span>}
                    </div>
                    {Array.isArray(ques?.subQuestions) && ques.subQuestions.length > 0 && (
                      <div className='d-flex gap-3 flex-column mt-3'>
                        <h6>Sub Questions:</h6>
                        {ques?.subQuestions?.map((subQues, index) => {
                          console.log(subQues, "subQues");

                          return (
                            <div className='question-wrapper sub_questions' key={index}>
                              <h5 className="ques-title mb-2">{subQues?.text}</h5>
                              <p className="m-0 ques-type "><strong>Question Type:</strong> {label}</p>
                              <p className="m-0 ques-type pt-2"><strong>Tooltip:</strong> {subQues?.tooltip}</p>
                              {Array.isArray(subQues?.options) && subQues.options.length > 0 && (
                                <ul className='d-flex flex-column gap-2 border-0'>
                                  {subQues.options.map((opt, index) => (
                                    <li key={index}>{opt?.label}</li>
                                  ))}
                                </ul>
                              )}
                              {subQues?.min && <span className='d-block'>Min: {subQues?.min}</span>}
                              {subQues?.max && <span>Max: {subQues?.max}</span>}
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </Accordion.Body>
                </div>
              </div>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </>
  );
};

export default SureveyDetails;
